import { FormGroup, FormGroupFeedback, IFormGroupProps, Intent, TimezonePicker } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import * as React from 'react';

interface ITimezoneField {
  disabled?: boolean;
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
}

export default function TimezoneField<T extends string>({ disabled = false, name, formGroupProps }: ITimezoneField) {
  const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasInitialError = meta.initialError;
  const hasError = meta.touched && meta.error;
  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <TimezonePicker
        value={field.value}
        onChange={helpers.setValue}
        fill={true}
        buttonProps={{ large: true }}
        intent={hasError || hasInitialError ? Intent.DANGER : Intent.NONE}
        disabled={disabled}
        usePortal={false}
      />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
      {!hasError && hasInitialError && (
        <FormGroupFeedback intent={Intent.DANGER}>{meta.initialError}</FormGroupFeedback>
      )}
    </FormGroup>
  );
}
